module.exports = __webpack_public_path__ + "img/sig.cbf2c0de.png";